import { formatNumber } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'floorIfAboveOne',
  standalone: false,
})
export class FloorIfAboveOnePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) public locale: string) {}

  transform(value: number, digitsInfo?: string): number | string {
    if (value > 1 || value < -1) {
      value = Math.floor(value);
    }

    return formatNumber(value, this.locale, digitsInfo);
  }
}
